const custAuth = {
    path: 'storeShortcut',
    name: 'storeShortcut',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'shortcut',
        icon: 'HSIconfont hs-icon-lighting',
        affix: true,
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeShortcutEsl',
            name: 'storeShortcutEsl',
            component: () => import('@/views/storeShortcutEsl'),
            meta: { code: 'shortcut:esl' }
        },
        {
            path: 'storeShortcutGoods',
            name: 'storeShortcutGoods',
            component: () => import('@/views/storeShortcutGoods'),
            meta: { code: 'shortcut:goods' }
        },
        {
            path: 'storeShortcutCustGoods',
            name: 'storeShortcutCustGoods',
            component: () => import('@/views/storeShortcutCustGoods'),
            meta: { code: 'shortcut:custGoods' }
        },
        {
            path: 'storeShortcutCdi',
            name: 'storeShortcutCdi',
            component: () => import('@/views/storeShortcutCdi'),
            meta: { code: 'shortcut:cdi' }
        },
        {
            path: 'storeShortcutCustCdi',
            name: 'storeShortcutCustCdi',
            component: () => import('@/views/custCdi'),
            meta: { code: 'shortcut:customercdi' }
        },
        {
            path: 'storeShortcutBindInfo',
            name: 'storeShortcutBindInfo',
            component: () => import('@/views/storeShortcutBindInfo'),
            meta: { code: 'shortcut:binding' }
        },
        {
            path: 'storeShortcutEslUpdate',
            name: 'storeShortcutEslUpdate',
            component: () => import('@/views/storeShortcutEslUpdate'),
            meta: { code: 'shortcut:eslUpdateHistory' }
        },
        {
            path: 'storeShortcutBindHistory',
            name: 'storeShortcutBindHistory',
            component: () => import('@/views/storeShortcutBindHistory'),
            meta: { code: 'shortcut:bindingHistory' }
        },
        {
            path: 'storeShortcutUsedEsl',
            name: 'storeShortcutUsedEsl',
            component: () => import('@/views/storeShortcutUsedEsl'),
            meta: { code: 'shortcut:eslUsage' }
        },
        {
            path: 'storeShortcutEslLog',
            name: 'storeShortcutEslLog',
            component: () => import('@/views/storeShortcutEslLog'),
            meta: { code: 'shortcut:eslOperationHistory' },
        },
    ]
};

export default custAuth;
